import httpClient from '../../httpClient';

/**
 * 회원가입 이메일 인증
 * @typedef {Object} obj
 * @param {string} email - user email
 */
function signupEmailVerify({ email }) {
  return httpClient({
    url: '/auth/signup/email',
    method: 'POST',
    data: {
      email,
    },
  });
}

export default signupEmailVerify;
